import { render, staticRenderFns } from "./CustomMap.vue?vue&type=template&id=396c7bdd&scoped=true"
import script from "./CustomMap.vue?vue&type=script&lang=js"
export * from "./CustomMap.vue?vue&type=script&lang=js"
import style0 from "./CustomMap.vue?vue&type=style&index=0&id=396c7bdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c7bdd",
  null
  
)

export default component.exports